import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AIChatbot from './AIChatbot';
import './Categories.css';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showChatbot, setShowChatbot] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch('/api/categories');
      const data = await response.json();
      setCategories(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setLoading(false);
    }
  };

  const handleAskAI = (category) => {
    setSelectedCategory(category);
    setShowChatbot(true);
  };

  const handleViewCategory = (categoryName) => {
    navigate(`/category/${encodeURIComponent(categoryName)}`);
  };

  if (loading) {
    return (
      <section id="categories" className="section">
        <div className="container">
          <div className="loading-text">Φόρτωση κατηγοριών...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="categories" className="section categories-section">
      <div className="container">
        <h2 className="section-title">Κατηγορίες IT Υπηρεσιών</h2>
        <p className="section-subtitle">
          Επιλέξτε την κατηγορία που σας ενδιαφέρει
        </p>

        <div className="categories-grid">
          {categories.map((category) => (
            <div key={category.id} className="category-card">
              <div className="category-icon">
                {category.image ? (
                  <img src={category.image} alt={category.name} className="category-image-icon" />
                ) : (
                  category.icon
                )}
              </div>
              <h3 className="category-name">{category.name}</h3>
              <p className="category-description">
                {category.description}
              </p>
              <div className="category-actions">
                <button 
                  className="btn btn-outline"
                  onClick={() => handleViewCategory(category.name)}
                >
                  Δείτε Περισσότερα
                </button>
                <button 
                  className="btn btn-ai"
                  onClick={() => handleAskAI(category.name)}
                  title="Ρωτήστε το AI"
                >
                  🤖 Ρωτήστε AI
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Category-specific AI Chatbot */}
      {showChatbot && (
        <AIChatbot 
          category={selectedCategory}
          onClose={() => {
            setShowChatbot(false);
            setSelectedCategory(null);
          }}
        />
      )}
    </section>
  );
}

export default Categories;
